import React from 'react';
import { Treemap } from 'recharts';
import data from '../fakeData';

const COLORS = [
  '#8889DD',
  '#9597E4',
  '#8DC77B',
  '#A5D297',
  '#E2CF45',
  '#F8C12D',
];

class CustomizedContent extends React.Component {
  render() {
    const {
      root,
      depth,
      x,
      y,
      width,
      height,
      index,
      // payload,
      colors,
      // rank,
      name,
    } = this.props;

    return (
      <g>
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          style={{
            fill:
              depth < 2
                ? colors[Math.floor(index / root.children.length * 6)]
                : 'none',
            strokeWidth: 2 / (depth + 1e-10),
            strokeOpacity: 1 / (depth + 1e-10),
          }}
        />
        {depth === 1 ? (
          <text
            x={x + width / 2}
            y={y + height / 2 + 7}
            textAnchor="middle"
            fontSize={14}
            fill={'black'}
            stroke="none"
          >
            {name.charAt(0).toUpperCase() + name.slice(1)}
          </text>
        ) : null}
      </g>
    );
  }
}
export default () => (
  <Treemap
    width={window.innerWidth}
    height={750}
    style={{ margin: '0 auto', shapeRendering: 'crispEdges' }}
    data={data}
    dataKey="size"
    ratio={4 / 3}
    stroke="#fff"
    fill="#8884d8"
    content={<CustomizedContent colors={COLORS} />}
  />
);



// WEBPACK FOOTER //
// ./src/components/Treemap.js